export const classroomOverviewPermission = {
  resource: "school.classrooms.overview",
  action: "manage",
};

export const classroomOverviewRouteChecks = [classroomOverviewPermission];

export const parentEmailsPermission = {
  resource: "reports.parent-emails",
  action: "view",
};
